<template>
	<content menu="获奖情况" :childmenus="childmenus" @childMenuChange = "childMenuChange"  :menuIndex="menuIndex" :location = "location"> 
		<chapter_list class="chapter_list" :datas="datas"  v-if="isShowChapterList"></chapter_list>	
		<image_list  v-else :path = "path" :count="count"></image_list>
	</content>
</template>


<script>
	import content from './content.vue'
	import chapter_list from "../exhibition/chapter_list.vue"
	import image_list from '../exhibition/image_list.vue'
	const cityData = require('../../assets/data/awards_condition.json')

	export default {
		name:"ApplicationForm",
		components:{
			content,
			chapter_list,
			image_list
		},
		props:{
		},
		data() {
			return {
				childmenus:[
				{
					name:"教师获奖",
                    datas:[
                        {name:'教师团队获奖',url:'/awards_condition',id:'40000'},
                        {name:'教师个人获奖',url:'/awards_condition',id:'40001'}
                    ]
				},
				{
					name:"学生获奖",
                    datas:[
                        {name:'学生创新创业大赛获奖',url:'/awards_condition',id:'40100'},
                        {name:'学生专业赛事',url:'/awards_condition',id:'40101'},
                        {name:'学生专利获批',url:'/awards_condition',id:'40102'},
						{name:'毕业生创业成效',url:'/awards_condition',id:'40103'}
                    ]
				}
				],
				datas:[],
                isShowChapterList:true,
                path:'awards_condition/01/',
                count:16,
                menuIndex:0,
                location:['获奖情况'],
			};
		},
		methods:{
			childMenuChange(index){
				// this.path = this.childmenus[index].path;
				// this.count = this.childmenus[index].count;
				// this.location = [];
				// this.location.push('获奖情况');
				// this.location.push(this.childmenus[index].name);

				this.isShowChapterList  =true;
                this.datas = this.childmenus[index].datas;
                this.$router.push({ query: { } })

                this.location = [];
				this.location.push('获奖情况');
				this.location.push(this.childmenus[index].name);

			}
		},
		created() {
			// this.path = this.childmenus[0].path;
			// 	this.count = this.childmenus[0].count;

			this.datas = this.childmenus[0].datas;
            var id =  this.$route.query.id;
           
            if(id === undefined){
                this.isShowChapterList =true;
                return;
            }

            this.isShowChapterList =false;
            let queryData = cityData.filter(function(data){
                return data.id == id;
            })
            this.path = queryData[0].path;
            this.count = queryData[0].count;

            let menuIndex = id.slice(1,3);
            this.menuIndex = menuIndex;


            this.location = [];
            this.location.push('获奖情况');
            let menuName = this.childmenus[Number(menuIndex)].name;
            this.location.push(menuName);
            let nameIndex =Number(id.slice(3,5));
            let name = this.childmenus[Number(menuIndex)].datas[nameIndex].name;
            this.location.push(name);
			console.log(this.isShowChapterList);
		}

	}
</script>

<style lang="scss" scoped>
.chapter_list{
	height: calc(100vh - 360px);
	
}
</style>